import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal, groupDelete, groupList, openModal } from '../../../../../redux/actions/action-creator';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import GroupAlter from '../../alter/accounting_masters/GroupAlter';
import GroupView from '../../view/accounting_masters/GroupView';
import { useDropdownKeyboardNavigation } from '../../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../../../../../components/Custom_Hooks/useDropdownScroll';
import HomeLayout from '../../../../../components/home_page/HomeLayout';
import Form from '../../../../../components/Form/Form';
import NavFooterLayout from '../../../../../components/NavNameOfComponent/NavFooterLayout';
import GroupCreate from '../../create/accounting_masters/Group';
import DeletConfirm from '../../../../../components/Modal/DeletConfirm';
import { useDelet } from '../../../../../components/Custom_Hooks/useDelete';
import { prepareFormData } from '../../../../../components/Custom_Hooks/useFormHandler';

const Group = () => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [all_data, setall_data] = useState([]);

    const { userData = null } = useSelector(state => state.auth);
    const modal_state = useSelector(state => state.common.modal_state);
    const dropdownRef = useRef(null);
    const [enabled, setEnabled] = useState(true);

    // fetch data -----------------------------
    useEffect(() => {
        setEnabled(true);
        const fetchData = async () => {
            try {
                const formdata = new FormData();
                formdata.append('company_id', userData?.id);
                const response = await dispatch(groupList(formdata));
                const array_list = [];

                const processSubGroups = async (subGroups, type, parent_name) => {
                    if (subGroups && subGroups.length > 0) {
                        for (const data of subGroups) {
                            array_list.push({ type, data, parent_name });
                            await processSubGroups(data.sub_primary_group1, type + 1, data?.name);
                        }
                    }
                };

                if (response?.data && response?.data?.length > 0) {
                    for (const data of response?.data) {
                        const ledgerLength = data?.ledger ? data?.ledger?.length : 0;
                        const groupLength = data?.groupName ? data?.groupName?.length : 0;
                        array_list.push({ type: 'primary', data, ledgerLength, groupLength });
                        await processSubGroups(data?.sub_primary_group1, 'secondary', data?.name);
                    }
                }
                //setall_data(array_list);
                const sortedData = [...array_list].sort((a, b) => {
                    const nameA = (a.data?.name || a.data?.ledger_name || "").toLowerCase();
                    const nameB = (b.data?.name || b.data?.ledger_name || "").toLowerCase();

                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                });
                setall_data(sortedData);
            } catch (error) {
                console.error('Error fetching group data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [modal_state?.group_update, modal_state?.modal_1, modal_state?.modal_2, modal_state?.group_view])

    // keyboard Functionality ----------------------------------------
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: all_data,
        state: modal_state?.group_update || modal_state?.modal_1 || modal_state?.modal_2 || modal_state?.group_view ? false : true,
        onItemSelect: (item) => {
            // navigate(`../alter_accounting_groupupdate/${item?.data?.id}`)
            if (!(modal_state?.modal_1 || modal_state?.modal_2 || modal_state?.group_update)) {
                dispatch(openModal('group_view'))
            }
        },
        onItemControlEnterSelect: (item) => {
            if (item?.data?.is_default == 1) return;
            if (!(modal_state?.modal_1 || modal_state?.modal_2 || modal_state?.group_view)) {
                dispatch(openModal('group_update'))
            }
        },
        onItemAltCSelect: (item) => {
            if (!(modal_state?.group_update || modal_state?.modal_2 || modal_state?.group_view)) {
                dispatch(openModal('modal_1'))
            }
        },
        onItemAltDSelect: (item) => {
            if (item?.data?.is_default == 1) return;
            if (!(modal_state?.group_update || modal_state?.modal_1 || modal_state?.group_view)) {
                dispatch(openModal('modal_2'))
            }
        },
    });
    // Scroll Functionality -------------------------------------
    useDropdownScroll({ dropdownRef, selectedItemIndex });

    const [data, setData] = useState({
        id: all_data[selectedItemIndex]?.data?.id,
        company_id: userData?.id
    })

    useEffect(() => {
        if (all_data[selectedItemIndex]) {
            setData({
                id: all_data[selectedItemIndex]?.data?.id,
                company_id: userData?.id,
            });
        }
    }, [selectedItemIndex, all_data]);

    // Delete Functionality ------------------------------
    const { delteItem, loadingDelete } = useDelet({
        prepareFormData: () => prepareFormData(data),
        submitForm: (data) => dispatch(groupDelete(data)),
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => delteItem(new Event('submit')),
            },
        ],
        closeModal: () => dispatch(closeModal('modal_2')),
        state: modal_state?.modal_2
    });
    //console.log(all_data);
    return (
        <HomeLayout>
            {modal_state?.modal_1 && (
                <div style={{ zIndex: 10000 }}>
                    <GroupCreate
                        title='Group Creation (Primary)'
                        closeModal_sec={() => dispatch(closeModal('modal_1'))}
                    />
                </div>)}
            {
                modal_state?.group_view
                && (
                    <div style={{ zIndex: 10000 }}>
                        <GroupView
                            data_to_view={data}
                            title='Group View'
                            closeModal_sec={() => dispatch(closeModal('group_view'))}
                        />
                    </div>
                )}
            {
                // location.pathname === `/alter_accounting_groupupdate/${id}`
                modal_state?.group_update
                && (
                    <div style={{ zIndex: 10000 }}>
                        <GroupAlter
                            data_to_update={data}
                            title='Group Alteration'
                            closeModal_sec={() => dispatch(closeModal('group_update'))}
                        />
                    </div>
                )}
            <Form
                title='List of Groups'
                col='col-12'
                loading={loading}
                Footer={MasterListFooter}
                createMasterEnabled={enabled}
                alterEnabled={all_data[selectedItemIndex]?.data?.is_default == 0 ? true : false}
                deleteEnabled={all_data[selectedItemIndex]?.data?.is_default == 0 ? true : false}
            >
                {
                    modal_state?.modal_2 ?
                        <div style={{ zIndex: 10000 }}>
                            <DeletConfirm
                                handleSubmit={delteItem}
                                loading={loadingDelete}
                                closeModal={() => dispatch(closeModal('modal_2'))}
                            />
                        </div>
                        : null
                }
                <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom  mt-0">
                    <div
                        className="col-1 font_size p-0 m-0 ps-3 text-end fw-bold"
                        style={{ width: "3%" }}
                    >
                        Sr
                    </div>
                    <div
                        className={`col-7 font_size p-0 m-0 ps-3 text-start fw-bold`}
                    >
                        Name of Group
                    </div>

                    <div
                        className="col-2 font_size m-0 p-0 ps-3 text-start fw-bold"
                    >
                        Under
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 ps-3 text-start fw-bold"
                    >
                        Type
                    </div>
                </div>
                <div className='row gx-0 p-0 mb-2' style={{ overflowY: 'hidden' }}>
                    <div className='col m-0 p-0' ref={dropdownRef} style={{ overflowY: 'auto', height: '78.3vh' }}>
                        {
                            all_data.map((item, index) => {
                                return (
                                    /*<div
                                        key={index}
                                        className={index === selectedItemIndex ? 'selected' : ''}
                                        style={{
                                            display: 'flex',
                                            textAlign: 'left',
                                            paddingLeft: 5,
                                            marginLeft: item.type === 'primary' ? 0 : item.type === 'secondary' ? 10 : item.type.startsWith('secondary') ? (item.type.length - 6) * 5 : 0
                                        }}
                                    >
                                        <Link
                                            onClick={() => setSelectedItemIndex(index)}
                                            className={'group_list_chart_of_account'}
                                            style={{ width: '100%' }}
                                        >
                                            {item.data.name}
                                        </Link>
                                    </div>*/
                                    <div
                                        key={index}
                                        onClick={() => setSelectedItemIndex(index)}
                                        style={{
                                            cursor: "pointer",
                                            marginLeft: item.type === 'primary' ? 0 : item.type === 'secondary' ? 10 : item.type.startsWith('secondary') ? (item.type.length - 6) * 5 : 0
                                        }}
                                        className={`row gx-0 p-0 m-0  mt-0 ${index === selectedItemIndex ? "selected" : ""}`}>
                                        <div
                                            className="col-1 font_size p-0 m-0 ps-3 text-end"
                                            style={{ width: "3%" }}
                                        >
                                            {index + 1}
                                        </div>
                                        <div
                                            className={`col-7 font_size p-0 m-0 ps-3 text-start ${item?.data?.is_default === '1' ? "fw-bold" : ""}`}
                                        >
                                            {item?.data?.name}
                                        </div>

                                        <div
                                            className="col-2 font_size m-0 p-0 ps-3 text-start"
                                        >
                                            {item?.data?.under_name || 'Primary'}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 ps-3 text-start"
                                        >
                                            {item?.data?.nature_of_group}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <NavFooterLayout>
                    <b className='ps-2'> {all_data.length} Groups</b>
                </NavFooterLayout>

            </Form>
        </HomeLayout>
    )
}
export default Group;
